module.exports = __webpack_public_path__ + "dbc476b4d3befbc13fc494a4b943c10e.svg";